import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
// Intended for use only with <input type="number"> elements that constrain value to
// a Number-able string
function validateNumber(label, value, max) {
  var min = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var lowercaseLabel = label.toLowerCase();
  if (value === '') {
    return "Please enter a ".concat(lowercaseLabel, ".");
  }
  var numberValue = Number(value);
  if (numberValue < Number(min) || Number(max) < numberValue) {
    return "Please input a ".concat(lowercaseLabel, " between ").concat(min, " and ").concat(max, ".");
  }
  return '';
}
export default validateNumber;